import { connect } from "react-redux";

import Features from "./Features";

const mapStateToProps = state => ({
    user: { ...state.user },
});

export default connect(mapStateToProps, null)(Features);
